import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectLandingState } from './selectLandingState'

export const selectInitPlanFinished = createSelector(
  [selectLandingState],
  ({ fetchPlanInitStatus }) => fetchPlanInitStatus === RequestStatus.FULFILLED
)
